import {Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';


@Component({
	selector: 'ui-alert',
	host: {class: 'ui-alert'},
	template: `
		<ui-modal [isHidden]="false" [closeable]="false" [title]="title" #modal [lg]="false">
			<div [innerHTML]="text"></div>
			<div class="modal-footer" style="margin-left: -17px;
    margin-right: -17px;
    margin-top: 15px;
    margin-bottom: 0;
    padding-bottom: 0px;">
				<button class="btn btn-success" *ngIf="confirm" (click)="onConfirm()">{{confirmText}}</button>
				<button class="btn btn-danger" *ngIf="confirm" (click)="onCancel()">{{cancelText}}</button>
				<button class="btn btn-sm bg-grey-important" *ngIf="!confirm" (click)="onOk()">{{okText}}</button>
			</div>
		</ui-modal>
	`
})
export class UIAlertComponent {
	@Input() title = 'Alert';
	@Input() text;
	@Output() onAction = new EventEmitter();
	@Input() confirm = false;
	@Input() confirmText = 'Confirm';
	@Input() cancelText = 'Cancel';
	@Input() okText = 'Close';

	onConfirm() {
		this.onAction.emit(true);
	}

	onCancel() {
		this.onAction.emit(false);
	}

	onOk() {
		this.onAction.emit(false);
	}
}
